export enum PairingCodeLength {
    PEGA_LEGACY = 4,
    BSP = 8
}
